import { Divider, Grid, Typography, Link } from '@mui/material';

import { Organization } from 'components';
import { InfoCell } from 'components/InfoCell';
import { UserManagementActions } from 'components/UserManagementActions';
import {
  getFullUserNameOrId,
  getLabel,
  userAccountStatusOptions,
} from 'helpers';
import { UserEditFormProps } from 'types';

import { settings } from '../../../config/settings';
import { UserOrgEdit } from './UserOrgEdit';
export const AdminUserEditForm = (props: UserEditFormProps) => {
  const { user, setUser, setUserRefresh } = props;
  const { email, account_status, id, organization } = user;
  return (
    <Grid
      container
      aria-label={
        'Edit page for User ' + user.first_name + ' ' + user.last_name
      }
    >
      <Grid item xs={8}>
        <Typography variant='h4'>{getFullUserNameOrId(user)} </Typography>
      </Grid>
      <Grid item xs={4}>
        <UserManagementActions
          user={user}
          setUser={setUser}
          user_url='/home/candidate_admin_dashboard/users'
        />
      </Grid>
      <Divider sx={{ marginTop: 2, marginBottom: 2, width: '100%' }} />

      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={6}>
              <InfoCell title='Username' value={email} />
            </Grid>
            <Grid item xs={6}>
              <InfoCell
                title='Account Status'
                value={getLabel({
                  value: account_status as string,
                  options: userAccountStatusOptions,
                })}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
        <Typography variant='h5'>Linked Employer</Typography>
        <Typography sx={{ maxWidth: '600px' }} variant='body1'>
          Users can only be assigned to one <Organization /> (parent). To edit
          the <Organization /> they are assigned to, click EDIT below. If you
          need to associate additional employers with an <Organization />, you
          may do that{' '}
          <Link
            href={
              settings.PUBLIC_URL +
              '/home/candidate_admin_dashboard/organizations'
            }
          >
            here
          </Link>
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ marginTop: 2 }}>
        <UserOrgEdit
          organization={organization}
          setUserState={setUser}
          userId={id}
          setUserRefresh={setUserRefresh}
        />
      </Grid>
    </Grid>
  );
};
